import { Checkbox } from '@timelyapp/react';
import React from 'react';
import styles from './ConfirmDeleteReport.module.scss';

interface Props {
  alsoDeleteShared: boolean;
  hasSharedReports: boolean;
  setAlsoDeleteShared: (value: boolean) => void;
}

export const ConfirmDeleteReport: React.FC<Props> = ({
  alsoDeleteShared,
  hasSharedReports,
  setAlsoDeleteShared,
}) => (
  <span
    className={styles.confirmDeleteReport}
    onClick={e => {
      e.stopPropagation();
    }}
  >
    Are you sure you want to delete this report?
    {hasSharedReports && (
      <Checkbox
        className={styles.checkbox}
        label="Also delete all shared versions of this report"
        checked={alsoDeleteShared}
        onChangeChecked={setAlsoDeleteShared}
      />
    )}
  </span>
);
